// Light value objects for the Hermes domain. Framework-free. These validate
// (or normalize) at the domain border and return a primitive or null — NOT
// classes — so aggregates can store plain values and stay trivially
// serializable. (MemoryScope is P2; do not add it here.)

import { HermesDomainError } from './errors.js';

export const DEFAULT_ROLE = 'general';

// requireNonEmpty — shared border guard for required string fields. Throws a
// HermesDomainError tagged with the caller's `code` (e.g. 'invalid_agent' /
// 'invalid_run') so each aggregate keeps its own error code while sharing one
// implementation. null/undefined/blank all fail.
export function requireNonEmpty(value, field, code) {
  if (value == null || String(value).trim() === '') {
    throw new HermesDomainError(code, `${field} required`);
  }
}

// AgentRole — a normalized, non-empty role string. Absent (null/undefined)
// falls back to DEFAULT_ROLE; an explicitly blank/whitespace string is an
// error (the caller meant to set a role and got it wrong).
export function AgentRole(role) {
  if (role == null) return DEFAULT_ROLE;
  const trimmed = String(role).trim();
  if (trimmed === '') {
    throw new HermesDomainError('invalid_value', 'role required');
  }
  return trimmed;
}

// ModelRef — the model identifier, or null meaning "use the default brain".
// Empty/blank/missing is a valid choice (null), never an error.
export function ModelRef(model) {
  if (model == null) return null;
  const trimmed = String(model).trim();
  return trimmed === '' ? null : trimmed;
}

// Cwd — the working directory, or null meaning "let the adapter resolve it".
// Empty/blank/missing is valid (null), never an error.
export function Cwd(cwd) {
  if (cwd == null) return null;
  const trimmed = String(cwd).trim();
  return trimmed === '' ? null : trimmed;
}
